// =============================================================================
// public-paths.ts — Prédicat de chemin PUBLIC (pré-auth), SOURCE UNIQUE partagée.
// =============================================================================
// Un chemin PUBLIC s'affiche SANS chrome (header / navigation) et SANS session authentifiée :
// landing « / », mentions légales, CGU, onboarding / activation / magic-link. Ce prédicat est
// l'UNIQUE source de vérité, consommée par :
//   1. router.tsx        — gating du chrome (AppShell) via le pathname du routeur (SEC-NAV-01).
//   2. auth-bootstrap.tsx — garde ANTI-LOOP du redirect proactif (window.location.pathname).
//   3. providers.tsx      — garde ANTI-LOOP de l'intercepteur 401 (window.location.pathname).
// Une seule liste = aucune dérive entre le gating de chrome et les gardes de redirect (une divergence
// rouvrirait une boucle de rechargement sur la landing — cf. le piège documenté dans le plan ARCH §3).
// DBU §2.1 l.550 / §3.1 l.2350 : « Aucune navigation latérale n'est disponible avant authentification ».

export const isPublicPath = (pathname: string): boolean =>
  pathname === '/' ||
  pathname === '/cgu' ||
  pathname === '/mentions-legales' ||
  pathname === '/onboarding' ||
  pathname.startsWith('/onboarding/');
